module.exports = __webpack_public_path__ + "img/sol_cap3.e7e55e02.png";